// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/vuetify-loader/lib/loader.js??ref--14-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./airplane_wind_chart.vue?vue&type=style&index=1&id=bf10e072&scoped=true&lang=css&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("7a0f8a2f", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/vuetify-loader/lib/loader.js??ref--14-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./airplane_wind_chart.vue?vue&type=style&index=1&id=bf10e072&scoped=true&lang=css&", function() {
     var newContent = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/vuetify-loader/lib/loader.js??ref--14-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./airplane_wind_chart.vue?vue&type=style&index=1&id=bf10e072&scoped=true&lang=css&");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}